import { createContext } from 'react'
import { IEnv } from './types'


export const EnvContext = createContext<IEnv>({
  primaryColor: 'secondary-black'
})